export default __webpack_public_path__ + "static/screen_2_03-307bd1d8c24fe204c7e3866eb7ec2260.svg";